export default function PenIcon({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.05225 15.1831L4.27979 15.8569C4.17236 15.896 4.07471 15.8716 3.98682 15.7837C3.90381 15.6958 3.88184 15.5981 3.9209 15.4907L4.63867 13.7695L12.8784 5.53711L14.2847 6.95068L6.05225 15.1831ZM14.9878 6.26221L13.5669 4.84131L14.3579 4.05762C14.5532 3.86719 14.7559 3.76465 14.9658 3.75C15.1758 3.73535 15.3711 3.81836 15.5518 3.99902L15.8374 4.28467C16.0132 4.47021 16.0962 4.66553 16.0864 4.87061C16.0767 5.07568 15.9741 5.27832 15.7788 5.47852L14.9878 6.26221Z" />
    </svg>
  );
}
